import { render, staticRenderFns } from "./ListCommunicationPage.vue?vue&type=template&id=4739dfb6"
import script from "./ListCommunicationPage.vue?vue&type=script&lang=js"
export * from "./ListCommunicationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports